import { Lightbox } from '@3pc/lightbox-photoswipe';
import { config, fixCounter } from '../../atoms/lightbox/lightbox';

const galleryEl = document.querySelectorAll('.text-media__lightbox');
const lightboxInstances = [];

galleryEl.forEach(gallery => {
  const children = gallery.querySelectorAll('.text-media__lightbox-toggle');
  const lightbox = new Lightbox({ ...{ gallery, children }, ...config });

  lightbox.init();
  fixCounter(lightbox);
  lightboxInstances.push(lightbox);
});
